import { IS_IOS_DEVICE } from 'voxguru-v1/utils/constants';

const getIsIOSDevice = () => localStorage.getItem(IS_IOS_DEVICE) === 'true';

export default getIsIOSDevice;
